// Mock data for Luxury Influencer Portfolio

export const influencerData = {
  name: "ALEXANDRA STONE",
  tagline: "Where Performance Meets Prestige",
  role: "Elite Fitness Creator & Brand Ambassador",
  followers: "1.4M+",
  monthlyReach: "9.2M",
  engagementRate: "5.8%",
  usaAudience: "72%",
  bio: "I don't just create content — I craft brand experiences that resonate with millions. With a decade of expertise in fitness and a curated audience of high-intent consumers, I transform brand partnerships into measurable success stories.",
  email: "partnerships@alexandrastone.com",
};

export const brandLogos = [
  { name: "Nike", displayed: "NIKE" },
  { name: "Gymshark", displayed: "GYMSHARK" },
  { name: "MyProtein", displayed: "MYPROTEIN" },
  { name: "Lululemon", displayed: "LULULEMON" },
  { name: "Reebok", displayed: "REEBOK" },
];

export const audienceData = {
  gender: [
    { label: "Female", value: 68, color: "#D4AF37" },
    { label: "Male", value: 32, color: "#3A3A3A" },
  ],
  ageGroups: [
    { range: "18-24", percentage: 28 },
    { range: "25-34", percentage: 45 },
    { range: "35-44", percentage: 18 },
    { range: "45+", percentage: 9 },
  ],
  topCities: [
    { city: "Los Angeles", percentage: 18 },
    { city: "New York", percentage: 15 },
    { city: "Miami", percentage: 12 },
    { city: "Chicago", percentage: 9 },
    { city: "Houston", percentage: 7 },
  ],
};

export const performanceMetrics = [
  { label: "Avg. Video Views", value: "2.4M", suffix: "" },
  { label: "Story Views", value: "890K", suffix: "/day" },
  { label: "Link Clicks", value: "45K", suffix: "/month" },
  { label: "Saves & Shares", value: "120K", suffix: "/month" },
];

export const contentShowcase = [
  {
    id: 1,
    image: "https://images.unsplash.com/photo-1550345332-09e3ac987658?w=600",
    title: "Nike Training Campaign",
    views: "4.2M",
    engagement: "8.2%",
  },
  {
    id: 2,
    image: "https://images.unsplash.com/photo-1567877383455-b2e3cb3cc8e1?w=600",
    title: "Gymshark Athletes",
    views: "3.8M",
    engagement: "7.4%",
  },
  {
    id: 3,
    image: "https://images.unsplash.com/photo-1572621988687-3fe290e7c0f6?w=600",
    title: "Lifestyle Collection",
    views: "2.9M",
    engagement: "6.8%",
  },
  {
    id: 4,
    image: "https://images.unsplash.com/photo-1633245691422-94f41bab9af1?w=600",
    title: "MyProtein Essentials",
    views: "3.1M",
    engagement: "7.1%",
  },
];

export const caseStudies = [
  {
    id: 1,
    brand: "NIKE",
    campaign: "Just Move Collection Launch",
    before: { followers: "1.2M", engagement: "4.2%" },
    after: { followers: "1.4M", engagement: "5.8%" },
    results: [
      { metric: "Brand Awareness", value: "+340%" },
      { metric: "Sales Generated", value: "$2.8M" },
      { metric: "New Followers", value: "+180K" },
    ],
    description: "A 6-week integrated campaign featuring exclusive workout content, behind-the-scenes access, and limited edition product reveals.",
  },
  {
    id: 2,
    brand: "GYMSHARK",
    campaign: "Summer Shred Series",
    before: { followers: "980K", engagement: "3.9%" },
    after: { followers: "1.2M", engagement: "5.2%" },
    results: [
      { metric: "Video Views", value: "18M+" },
      { metric: "Conversion Rate", value: "12.4%" },
      { metric: "ROI", value: "840%" },
    ],
    description: "An 8-week transformation series that documented real results while showcasing Gymshark's premium activewear line.",
  },
];

export const services = [
  {
    id: 1,
    title: "Brand Partnerships",
    description: "Strategic long-term collaborations that integrate your brand seamlessly into premium content.",
    icon: "handshake",
  },
  {
    id: 2,
    title: "Content Creation",
    description: "High-production value content tailored for your brand's aesthetic and marketing objectives.",
    icon: "camera",
  },
  {
    id: 3,
    title: "Campaign Strategy",
    description: "Full-service campaign development from concept to execution with measurable KPIs.",
    icon: "target",
  },
  {
    id: 4,
    title: "Event Appearances",
    description: "Exclusive appearances, speaking engagements, and brand activations.",
    icon: "calendar",
  },
];

export const testimonials = [
  {
    id: 1,
    quote: "Alexandra doesn't just promote products — she transforms them into aspirational lifestyle choices. Her audience trusts her implicitly, and that trust translated directly into our best campaign performance ever.",
    author: "Sarah Mitchell",
    role: "Global Marketing Director",
    company: "Nike",
  },
  {
    id: 2,
    quote: "Working with Alexandra elevated our entire brand perception. Her attention to detail and commitment to authentic storytelling is unmatched in the industry.",
    author: "James Chen",
    role: "Head of Influencer Partnerships",
    company: "Gymshark",
  },
  {
    id: 3,
    quote: "The ROI we achieved with Alexandra exceeded all projections. She's not just an influencer — she's a strategic marketing partner who understands business objectives.",
    author: "Emma Rodriguez",
    role: "Brand Strategy Lead",
    company: "MyProtein",
  },
];

export const images = {
  hero: "https://images.unsplash.com/photo-1570814711971-513cf0a0a0f8?w=1920&q=80",
  about: "https://images.unsplash.com/photo-1708011108776-45ad9e625269?w=800&q=80",
  editorial: "https://images.unsplash.com/photo-1633245691422-94f41bab9af1?w=800&q=80",
};
